import axios from './../../../axios';
import React, { useState } from 'react'

function DeleteNotice({ setDeleteNotice, noticeId, refatch }) {

    console.log("noticeId", noticeId)
    let Teacher_Id = JSON.parse(localStorage.getItem("Teacher_id"));
    const [isInProgress, setIsInProgress] = useState(false);

    const handleDeleteNotice = async () => {
        setIsInProgress(true);
        let req = {
            teacher_id: Teacher_Id,
        };
        try {
            await axios.delete(`api/v1/noticeBoard/notice/delete/${noticeId}`, { data: req });
            refatch()
            setDeleteNotice(false);
        } catch (error) {
            setIsInProgress(false);
            console.log(error);
        }
    };
    return (
        <div className=" delete_query_transprant_body ">
            <div className=" p-3 d-flex align-items-center justify-content-center flex-column delete_query_container shadow">
                <div className=" col-12 d-flex align-items-center justify-content-center flex-column text-center">
                    <span className="mt-2 mb-5 delete_query_text">
                        Are you sure you want to delete this notice?
                    </span>
                    <div className="col-12 p-0 gap-3 flex-wrap d-flex justify-content-center ">
                        <button
                            disabled={isInProgress}
                            className="btn btn-danger col-sm-5 query_delete_btn"
                            onClick={handleDeleteNotice}
                        >
                            Yes
                        </button>
                        <button
                            disabled={isInProgress}
                            className="btn btn-danger col-sm-5 query_delete_btn default_deleteq_uery_no"
                            onClick={(e) => setDeleteNotice(false)}
                        >
                            No
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DeleteNotice